import { formatLxBxH, parseLxBxH, type LxBxHParts } from '@/utils/lxBxH'

interface LxBxHInputProps {
  value: string
  onChange: (formatted: string) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  autoFocus?: boolean
  variant?: 'chip' | 'field'
}

const LxBxHInput = ({
  value,
  onChange,
  onKeyDown,
  autoFocus,
  variant = 'chip',
}: LxBxHInputProps) => {
  const parts = parseLxBxH(value)

  const setPart = (key: keyof LxBxHParts, next: string) => {
    onChange(formatLxBxH({ ...parts, [key]: next }))
  }

  const inputCls =
    variant === 'field'
      ? 'min-w-0 flex-1 px-2 py-2 text-sm text-center border border-slate-300 rounded-md focus:outline-none focus:border-[#1E3A5F] bg-white text-slate-800'
      : 'min-w-0 flex-1 text-sm text-center text-slate-800 bg-transparent focus:outline-none border-b border-slate-200 focus:border-[#1E3A5F] py-0.5 transition-colors'

  return (
    <div className="flex items-center gap-1.5">
      <input
        autoFocus={autoFocus}
        type="text"
        inputMode="decimal"
        placeholder="L"
        value={parts.l}
        onChange={e => setPart('l', e.target.value)}
        onKeyDown={onKeyDown}
        className={inputCls}
        style={variant === 'field' ? { minHeight: 44 } : undefined}
        aria-label="Lengde"
      />
      <span className="text-slate-400 font-semibold text-sm shrink-0 select-none">x</span>
      <input
        type="text"
        inputMode="decimal"
        placeholder="B"
        value={parts.b}
        onChange={e => setPart('b', e.target.value)}
        onKeyDown={onKeyDown}
        className={inputCls}
        style={variant === 'field' ? { minHeight: 44 } : undefined}
        aria-label="Bredde"
      />
      <span className="text-slate-400 font-semibold text-sm shrink-0 select-none">x</span>
      <input
        type="text"
        inputMode="decimal"
        placeholder="H"
        value={parts.h}
        onChange={e => setPart('h', e.target.value)}
        onKeyDown={onKeyDown}
        className={inputCls}
        style={variant === 'field' ? { minHeight: 44 } : undefined}
        aria-label="Høyde"
      />
    </div>
  )
}

export default LxBxHInput
